const base = {
  mode: "hagen",
  ke: "hagen-ke-01",
  reviewStatus: "beta-ready",
};

const q = (exercise) => ({ ...base, ...exercise });

export const exercises = [
  q({
    id: "hagen-bgb-at1-001",
    topic: "KE 1 - Privatrechtssystem",
    kind: "single",
    level: 1,
    priority: 1,
    skill: "definition",
    estimatedSeconds: 35,
    sources: ["hagenKe1", "bgb"],
    title: "Buergerliches Recht als Privatrecht",
    prompt: "Wodurch ist das buergerliche Recht im System des deutschen Rechts im Kern gekennzeichnet?",
    options: [
      { text: "Es regelt typischerweise Rechtsbeziehungen gleichgeordneter Privatrechtssubjekte.", correct: true },
      { text: "Es regelt ausschliesslich das Verhaeltnis zwischen Staat und Buerger.", correct: false },
      { text: "Es gilt nur fuer Kaufleute und Handelsgesellschaften.", correct: false },
      { text: "Es besteht vor allem aus Strafnormen zum Schutz des Eigentums.", correct: false },
    ],
    explanation: "Das BGB ist Kern des allgemeinen Privatrechts. Typisch ist die rechtliche Gleichordnung der Beteiligten, nicht staatliche Ueber-/Unterordnung.",
  }),

  q({
    id: "hagen-bgb-at1-002",
    topic: "KE 1 - Privatrechtssystem",
    kind: "single",
    level: 1,
    priority: 2,
    skill: "distinction",
    estimatedSeconds: 40,
    sources: ["hagenKe1"],
    title: "Privatrecht oder oeffentliches Recht",
    prompt: "Welche Abgrenzung ist fuer die Einordnung als Privatrecht besonders typisch?",
    options: [
      { text: "Gleichordnung der Beteiligten und eigenverantwortliche Gestaltung privater Rechtsbeziehungen.", correct: true },
      { text: "Handeln eines Staates genuegt immer fuer Privatrecht.", correct: false },
      { text: "Sobald Geld gezahlt wird, liegt zwingend oeffentliches Recht vor.", correct: false },
      { text: "Privatrecht liegt nur vor, wenn beide Parteien Verbraucher sind.", correct: false },
    ],
    explanation: "Der wichtigste Einstieg ist die Struktur des Rechtsverhaeltnisses. Privatrecht arbeitet typischerweise mit Gleichordnung; oeffentliches Recht haeufig mit Hoheitsgewalt.",
  }),

  q({
    id: "hagen-bgb-at1-003",
    topic: "KE 1 - BGB-Systematik",
    kind: "multi",
    level: 1,
    priority: 2,
    skill: "definition",
    estimatedSeconds: 45,
    sources: ["hagenKe1", "bgb"],
    title: "Fuenf Buecher des BGB",
    prompt: "Welche Bereiche gehoeren zur Grundsystematik des BGB? (Mehrere Antworten moeglich)",
    options: [
      { text: "Allgemeiner Teil", correct: true },
      { text: "Schuldrecht", correct: true },
      { text: "Sachenrecht", correct: true },
      { text: "Strafprozessrecht", correct: false },
    ],
    explanation: "Das BGB gliedert sich in Allgemeinen Teil, Schuldrecht, Sachenrecht, Familienrecht und Erbrecht. Strafprozessrecht gehoert nicht dazu.",
  }),

  q({
    id: "hagen-bgb-at1-004",
    topic: "KE 1 - Rechtsanwendung",
    kind: "single",
    level: 1,
    priority: 1,
    skill: "schema",
    estimatedSeconds: 45,
    sources: ["hagenKe1"],
    title: "Vom Sachverhalt zur Norm",
    prompt: "Was ist der erste juristisch saubere Schritt, wenn ein Fall geloest werden soll?",
    options: [
      { text: "Klaeren, wer was von wem verlangt und welche Anspruchsgrundlage diese Rechtsfolge tragen koennte.", correct: true },
      { text: "Sofort ein gerechtes Ergebnis formulieren und danach passende Normen suchen.", correct: false },
      { text: "Alle im Skript genannten Normen der Reihe nach wiederholen.", correct: false },
      { text: "Zunaechst nur die moralische Verantwortlichkeit der Beteiligten bewerten.", correct: false },
    ],
    explanation: "Zivilrechtliche Fallbearbeitung beginnt mit dem Begehren und einer tragfaehigen Anspruchsgrundlage. Danach werden Tatbestandsmerkmale geprueft.",
  }),

  q({
    id: "hagen-bgb-at1-005",
    topic: "KE 1 - Privatautonomie",
    kind: "single",
    level: 1,
    priority: 1,
    skill: "definition",
    estimatedSeconds: 35,
    sources: ["hagenKe1", "bgb311"],
    title: "Privatautonomie",
    prompt: "Welche Aussage beschreibt den Grundsatz der Privatautonomie am besten?",
    options: [
      { text: "Private koennen ihre Rechtsverhaeltnisse grundsaetzlich selbst gestalten, insbesondere durch Vertrag.", correct: true },
      { text: "Vertraege sind nur wirksam, wenn eine Behoerde sie genehmigt.", correct: false },
      { text: "Jede privatautonome Vereinbarung ist unabhaengig von zwingendem Recht wirksam.", correct: false },
      { text: "Privatautonomie bedeutet, dass Gerichte Vertraege nie kontrollieren duerfen.", correct: false },
    ],
    explanation: "Privatautonomie ist Gestaltungsfreiheit. Sie wird aber durch zwingendes Recht, Schutzvorschriften und Generalklauseln begrenzt.",
  }),

  q({
    id: "hagen-bgb-at1-006",
    topic: "KE 1 - Privatautonomie",
    kind: "multi",
    level: 2,
    priority: 1,
    skill: "distinction",
    estimatedSeconds: 55,
    sources: ["hagenKe1"],
    title: "Erscheinungsformen der Vertragsfreiheit",
    prompt: "Welche Aspekte gehoeren typischerweise zur Vertragsfreiheit? (Mehrere Antworten moeglich)",
    options: [
      { text: "Abschlussfreiheit", correct: true },
      { text: "Inhaltsfreiheit", correct: true },
      { text: "Formfreiheit als Grundsatz", correct: true },
      { text: "Pflicht, jeden angebotenen Vertrag anzunehmen", correct: false },
    ],
    explanation: "Vertragsfreiheit bedeutet vor allem Freiheit im Ob, Mit wem, Wie und Mit welchem Inhalt. Sie ist aber nicht schrankenlos.",
  }),

  q({
    id: "hagen-bgb-at1-007",
    topic: "KE 1 - Dispositives Recht",
    kind: "single",
    level: 1,
    priority: 1,
    skill: "definition",
    estimatedSeconds: 35,
    sources: ["hagenKe1", "bgb"],
    title: "Dispositives Recht",
    prompt: "Was ist dispositives Recht?",
    options: [
      { text: "Gesetzesrecht, das gilt, wenn die Parteien nichts anderes wirksam vereinbart haben.", correct: true },
      { text: "Gesetzesrecht, von dem niemals abgewichen werden darf.", correct: false },
      { text: "Nur Richterrecht ohne gesetzliche Grundlage.", correct: false },
      { text: "Recht, das nur fuer Verbraucher gilt.", correct: false },
    ],
    explanation: "Dispositives Recht ist nachgiebiges Recht. Es fuellt die privatautonome Regelung, wenn die Parteien keine wirksame eigene Regel getroffen haben.",
  }),

  q({
    id: "hagen-bgb-at1-008",
    topic: "KE 1 - Grenzen der Privatautonomie",
    kind: "single",
    level: 2,
    priority: 2,
    skill: "mini_case",
    estimatedSeconds: 65,
    sources: ["hagenKe1", "bgb"],
    title: "Zwingendes Recht",
    prompt: "A und B vereinbaren eine Klausel, die eine zwingende Verbraucherschutznorm ausschliessen soll. Wie ist die Klausel einzuordnen?",
    options: [
      { text: "Die Privatautonomie endet dort, wo zwingendes Recht abweichende Vereinbarungen nicht zulaesst.", correct: true },
      { text: "Die Klausel ist immer wirksam, weil Vertrage privatautonom geschlossen werden.", correct: false },
      { text: "Zwingendes Recht gilt nur im Strafrecht.", correct: false },
      { text: "Die Klausel wird automatisch zu dispositivem Recht.", correct: false },
    ],
    explanation: "Privatautonomie ist ein Grundprinzip, aber sie steht nicht ueber zwingenden Schutzentscheidungen des Gesetzes.",
  }),

  q({
    id: "hagen-bgb-at1-009",
    topic: "KE 1 - Vertrauensgrundsatz",
    kind: "single",
    level: 2,
    priority: 2,
    skill: "distinction",
    estimatedSeconds: 55,
    sources: ["hagenKe1"],
    title: "Warum Vertrauen zaehlt",
    prompt: "Welche Funktion hat der Vertrauensgrundsatz im Kontext von Willenserklaerungen?",
    options: [
      { text: "Er erklaert, warum erklaertes Verhalten unter Umstaenden zugerechnet wird, obwohl der innere Wille abweicht.", correct: true },
      { text: "Er macht den geheimen inneren Willen immer allein entscheidend.", correct: false },
      { text: "Er gilt nur bei notariellen Rechtsgeschaeften.", correct: false },
      { text: "Er ersetzt die Pruefung des Zugangs.", correct: false },
    ],
    explanation: "Rechtsverkehr braucht Verlaesslichkeit. Deshalb kann der objektive Erklaerungswert einer Handlung wichtiger sein als ein nicht erkennbarer innerer Vorbehalt.",
  }),

  q({
    id: "hagen-bgb-at1-010",
    topic: "KE 1 - Rechtsgeschaeft",
    kind: "single",
    level: 1,
    priority: 1,
    skill: "definition",
    estimatedSeconds: 35,
    sources: ["hagenKe1"],
    title: "Begriff des Rechtsgeschaefts",
    prompt: "Was ist fuer ein Rechtsgeschaeft unverzichtbar?",
    options: [
      { text: "Mindestens eine Willenserklaerung, die auf eine Rechtsfolge gerichtet ist.", correct: true },
      { text: "Immer zwei uebereinstimmende Willenserklaerungen.", correct: false },
      { text: "Immer eine notarielle Beurkundung.", correct: false },
      { text: "Immer eine tatsaechliche Leistungshandlung.", correct: false },
    ],
    explanation: "Ein Rechtsgeschaeft kann einseitig oder mehrseitig sein. Unverzichtbarer Kern ist mindestens eine Willenserklaerung.",
  }),

  q({
    id: "hagen-bgb-at1-011",
    topic: "KE 1 - Willenserklaerung",
    kind: "multi",
    level: 1,
    priority: 1,
    skill: "definition",
    estimatedSeconds: 45,
    sources: ["hagenKe1"],
    title: "Subjektiver Tatbestand",
    prompt: "Welche Elemente gehoeren klassisch zum subjektiven Tatbestand einer Willenserklaerung? (Mehrere Antworten moeglich)",
    options: [
      { text: "Handlungswille", correct: true },
      { text: "Erklaerungsbewusstsein", correct: true },
      { text: "Rechtsfolgewille", correct: true },
      { text: "Notarielle Belehrung", correct: false },
    ],
    explanation: "Der subjektive Tatbestand wird regelmaessig mit Handlungswille, Erklaerungsbewusstsein und Rechtsfolgewille beschrieben.",
  }),

  q({
    id: "hagen-bgb-at1-012",
    topic: "KE 1 - Willenserklaerung",
    kind: "single",
    level: 2,
    priority: 1,
    skill: "mini_case",
    estimatedSeconds: 70,
    sources: ["hagenKe1"],
    title: "Objektiver Erklaerungstatbestand",
    prompt: "A hebt auf einer Auktion die Hand, um einen Freund zu gruessen. Der Auktionator versteht dies als Gebot. Woran knuepft die Frage an, ob A eine Willenserklaerung zurechenbar abgegeben hat?",
    options: [
      { text: "An den objektiven Erklaerungswert des Verhaltens und daran, ob A den Rechtsschein zurechenbar gesetzt hat.", correct: true },
      { text: "Allein daran, ob A innerlich kaufen wollte.", correct: false },
      { text: "Allein daran, ob der Auktionator gutglaeubig war.", correct: false },
      { text: "Daran, ob bereits Eigentum uebertragen wurde.", correct: false },
    ],
    explanation: "Bei fehlendem Rechtsfolgewillen ist entscheidend, ob das Verhalten aus Empfaengersicht Erklaerungswert hatte und dem Handelnden zurechenbar ist.",
  }),

  q({
    id: "hagen-bgb-at1-013",
    topic: "KE 1 - Willenserklaerung",
    kind: "single",
    level: 2,
    priority: 2,
    skill: "distinction",
    estimatedSeconds: 55,
    sources: ["hagenKe1"],
    title: "Willenserklaerung oder Realakt",
    prompt: "Welche Aussage grenzt Willenserklaerung und Realakt richtig ab?",
    options: [
      { text: "Die Willenserklaerung ist auf eine Rechtsfolge gerichtet; der Realakt loest Rechtsfolgen unabhaengig von einem Rechtsfolgewillen aus.", correct: true },
      { text: "Ein Realakt ist immer unwirksam.", correct: false },
      { text: "Eine Willenserklaerung kann nie durch Verhalten abgegeben werden.", correct: false },
      { text: "Realakte gibt es nur im oeffentlichen Recht.", correct: false },
    ],
    explanation: "Bei der Willenserklaerung traegt der erklaerte Wille die Rechtsfolge. Beim Realakt knuepft das Recht an ein tatsaechliches Verhalten an.",
  }),

  q({
    id: "hagen-bgb-at1-014",
    topic: "KE 1 - Willenserklaerung",
    kind: "single",
    level: 2,
    priority: 2,
    skill: "distinction",
    estimatedSeconds: 55,
    sources: ["hagenKe1"],
    title: "Unverbindliche Erklaerung",
    prompt: "Welche Formulierung spricht am ehesten gegen einen Rechtsbindungswillen?",
    options: [
      { text: "'Ich koennte mir vorstellen, dir das Fahrrad vielleicht zu verkaufen.'", correct: true },
      { text: "'Ich verkaufe dir mein Fahrrad fuer 200 Euro.'", correct: false },
      { text: "'Ich nehme dein Angebot ueber 200 Euro an.'", correct: false },
      { text: "'Der Kaufpreis betraegt 200 Euro, Zahlung morgen.'", correct: false },
    ],
    explanation: "Vage, unverbindliche oder vorbereitende Aussagen sind regelmaessig noch keine rechtsgeschaeftliche Bindung. Der objektive Empfaengerhorizont entscheidet.",
  }),

  q({
    id: "hagen-bgb-at1-015",
    topic: "KE 1 - Zugang",
    kind: "single",
    level: 1,
    priority: 1,
    skill: "definition",
    estimatedSeconds: 40,
    sources: ["hagenKe1", "bgb130"],
    title: "Zugang unter Abwesenden",
    prompt: "Wann geht eine empfangsbeduerftige Willenserklaerung unter Abwesenden grundsaetzlich zu?",
    options: [
      { text: "Wenn sie so in den Machtbereich des Empfaengers gelangt, dass unter normalen Umstaenden mit Kenntnisnahme zu rechnen ist.", correct: true },
      { text: "Erst wenn der Empfaenger sie tatsaechlich gelesen hat.", correct: false },
      { text: "Bereits mit Absendung durch den Erklaerenden.", correct: false },
      { text: "Nur wenn der Empfaenger den Zugang bestaetigt.", correct: false },
    ],
    explanation: "Par. 130 Abs. 1 BGB knuepft an Zugang an: Machtbereich plus normale Kenntnisnahmemoeglichkeit genuegen grundsaetzlich.",
  }),

  q({
    id: "hagen-bgb-at1-016",
    topic: "KE 1 - Zugang",
    kind: "single",
    level: 2,
    priority: 1,
    skill: "mini_case",
    estimatedSeconds: 65,
    sources: ["hagenKe1", "bgb130"],
    title: "Brief im Briefkasten",
    prompt: "A wirft B um 23:30 Uhr eine Kuendigung in den privaten Briefkasten. Wann geht sie typischerweise zu?",
    options: [
      { text: "Erst zu dem Zeitpunkt, zu dem nach der Verkehrsanschauung am naechsten Tag mit Leerung zu rechnen ist.", correct: true },
      { text: "Sofort um 23:30 Uhr, weil der Brief physisch im Briefkasten liegt.", correct: false },
      { text: "Erst wenn B den Brief tatsaechlich liest.", correct: false },
      { text: "Nie, weil Briefe keine empfangsbeduerftigen Erklaerungen sein koennen.", correct: false },
    ],
    explanation: "Zugang verlangt neben dem Machtbereich eine normale Kenntnisnahmemoeglichkeit. Spaet nachts rechnet man regelmaessig nicht mehr mit Briefkastenleerung.",
  }),

  q({
    id: "hagen-bgb-at1-017",
    topic: "KE 1 - Zugang",
    kind: "single",
    level: 2,
    priority: 2,
    skill: "mini_case",
    estimatedSeconds: 55,
    sources: ["hagenKe1", "bgb130"],
    title: "E-Mail-Zugang",
    prompt: "Eine E-Mail geht waehrend ueblicher Geschaeftszeiten im geschaeftlichen Postfach des Empfaengers ein. Was ist fuer den Zugang entscheidend?",
    options: [
      { text: "Ob sie in den elektronischen Machtbereich gelangt ist und unter normalen Umstaenden mit Kenntnisnahme zu rechnen ist.", correct: true },
      { text: "Ob der Empfaenger sie bereits beantwortet hat.", correct: false },
      { text: "Ob der Absender eine Lesebestaetigung erhalten hat.", correct: false },
      { text: "Ob die E-Mail zusaetzlich per Post verschickt wurde.", correct: false },
    ],
    explanation: "Auch bei elektronischer Kommunikation bleibt die Grundidee: Machtbereich und regelmaessige Kenntnisnahmemoeglichkeit.",
  }),

  q({
    id: "hagen-bgb-at1-018",
    topic: "KE 1 - Widerruf",
    kind: "single",
    level: 2,
    priority: 1,
    skill: "mini_case",
    estimatedSeconds: 60,
    sources: ["hagenKe1", "bgb130"],
    title: "Widerruf vor Zugang",
    prompt: "A schickt B per Brief ein Vertragsangebot. Kurz darauf sendet A einen Widerruf per E-Mail, der B vor dem Brief erreicht. Was gilt?",
    options: [
      { text: "Das Angebot wird nicht wirksam, wenn der Widerruf vorher oder gleichzeitig zugeht.", correct: true },
      { text: "Das Angebot bleibt wirksam, weil der Brief zuerst abgesendet wurde.", correct: false },
      { text: "Der Widerruf ist nur wirksam, wenn er ebenfalls per Brief erfolgt.", correct: false },
      { text: "Der Widerruf macht das Angebot erst nach Ablauf einer Wochenfrist unwirksam.", correct: false },
    ],
    explanation: "Nach Par. 130 Abs. 1 S. 2 BGB wird die Erklaerung nicht wirksam, wenn vorher oder gleichzeitig ein Widerruf zugeht.",
  }),

  q({
    id: "hagen-bgb-at1-019",
    topic: "KE 1 - Vertragsschluss",
    kind: "single",
    level: 1,
    priority: 1,
    skill: "definition",
    estimatedSeconds: 35,
    sources: ["hagenKe1", "bgb145"],
    title: "Angebot",
    prompt: "Welche Eigenschaft muss ein Angebot zum Vertragsschluss haben?",
    options: [
      { text: "Es muss so bestimmt sein, dass der andere Teil durch schlichtes Ja den Vertrag zustande bringen kann.", correct: true },
      { text: "Es muss immer schriftlich abgegeben werden.", correct: false },
      { text: "Es muss immer eine Annahmefrist von mindestens sieben Tagen enthalten.", correct: false },
      { text: "Es darf noch keine wesentlichen Vertragsbestandteile enthalten.", correct: false },
    ],
    explanation: "Ein Angebot muss die wesentlichen Vertragsbestandteile enthalten und Bindungswillen erkennen lassen.",
  }),

  q({
    id: "hagen-bgb-at1-020",
    topic: "KE 1 - Vertragsschluss",
    kind: "single",
    level: 2,
    priority: 1,
    skill: "distinction",
    estimatedSeconds: 55,
    sources: ["hagenKe1", "bgb145"],
    title: "Invitatio ad offerendum",
    prompt: "Ein Haendler stellt eine Kamera mit Preisschild ins Schaufenster. Kunde K sagt: 'Die nehme ich.' Wie ist die Auslage regelmaessig einzuordnen?",
    options: [
      { text: "Als invitatio ad offerendum; K gibt regelmaessig erst das Angebot ab.", correct: true },
      { text: "Als bindendes Angebot des Haendlers, das K nur annimmt.", correct: false },
      { text: "Als Annahme eines noch unbekannten Kundenangebots.", correct: false },
      { text: "Als nicht rechtsgeschaeftliches Verhalten ohne jede Bedeutung.", correct: false },
    ],
    explanation: "Schaufenster- und Katalogangebote sind meist Einladungen zur Angebotsabgabe. Der Haendler will sich Vorrat, Bonitaet und Irrtuemer vorbehalten.",
  }),

  q({
    id: "hagen-bgb-at1-021",
    topic: "KE 1 - Vertragsschluss",
    kind: "single",
    level: 2,
    priority: 2,
    skill: "mini_case",
    estimatedSeconds: 60,
    sources: ["hagenKe1", "bgb145"],
    title: "Automat als Angebot",
    prompt: "Ein funktionsfaehiger Warenautomat zeigt Ware und Preis. K wirft den passenden Betrag ein. Wie laesst sich der Vertragsschluss regelmaessig konstruieren?",
    options: [
      { text: "Der Automat enthaelt regelmaessig ein antizipiertes Angebot, das K durch Einwurf des Geldes annimmt.", correct: true },
      { text: "Der Einwurf ist immer nur eine unverbindliche Anfrage.", correct: false },
      { text: "Ein Vertrag entsteht erst, wenn ein Mitarbeiter zustimmt.", correct: false },
      { text: "Automaten koennen nie am Vertragsschluss beteiligt sein.", correct: false },
    ],
    explanation: "Bei Automaten spricht die Verkehrsanschauung oft fuer ein bindendes Angebot an jeden, der die vorgesehene Handlung vornimmt.",
  }),

  q({
    id: "hagen-bgb-at1-022",
    topic: "KE 1 - Annahme",
    kind: "single",
    level: 1,
    priority: 1,
    skill: "definition",
    estimatedSeconds: 35,
    sources: ["hagenKe1", "bgb147"],
    title: "Annahmefrist unter Anwesenden",
    prompt: "Wann kann ein unter Anwesenden gemachtes Angebot nach Par. 147 Abs. 1 BGB grundsaetzlich angenommen werden?",
    options: [
      { text: "Nur sofort.", correct: true },
      { text: "Innerhalb von zwei Wochen.", correct: false },
      { text: "Bis zum Ende des naechsten Werktags.", correct: false },
      { text: "Solange der Antragende nicht widerspricht.", correct: false },
    ],
    explanation: "Bei Angeboten unter Anwesenden verlangt Par. 147 Abs. 1 BGB grundsaetzlich sofortige Annahme.",
  }),

  q({
    id: "hagen-bgb-at1-023",
    topic: "KE 1 - Annahme",
    kind: "single",
    level: 2,
    priority: 1,
    skill: "mini_case",
    estimatedSeconds: 55,
    sources: ["hagenKe1", "bgb150"],
    title: "Verspaetete Annahme",
    prompt: "B nimmt As Angebot erst nach Ablauf der Annahmefrist an. Welche Rechtsfolge ordnet Par. 150 Abs. 1 BGB an?",
    options: [
      { text: "Die verspaetete Annahme gilt als neuer Antrag.", correct: true },
      { text: "Der Vertrag kommt rueckwirkend zustande.", correct: false },
      { text: "Die Annahme ist stets nichtig und rechtlich unbeachtlich.", correct: false },
      { text: "A ist automatisch schadensersatzpflichtig.", correct: false },
    ],
    explanation: "Die verspaetete Annahme ist kein Vertragsschluss zum alten Angebot, sondern ein neuer Antrag.",
  }),

  q({
    id: "hagen-bgb-at1-024",
    topic: "KE 1 - Annahme",
    kind: "single",
    level: 2,
    priority: 1,
    skill: "mini_case",
    estimatedSeconds: 55,
    sources: ["hagenKe1", "bgb150"],
    title: "Annahme unter Aenderungen",
    prompt: "B antwortet auf As Verkaufsangebot: 'Einverstanden, aber nur bei Lieferung naechste Woche statt morgen.' Was gilt?",
    options: [
      { text: "Das ist Ablehnung verbunden mit einem neuen Antrag.", correct: true },
      { text: "Der Vertrag kommt mit As urspruenglichem Inhalt zustande.", correct: false },
      { text: "Der Vertrag kommt mit Bs Inhalt automatisch zustande.", correct: false },
      { text: "Es liegt immer ein wirksamer Vertrag mit offenem Nebenpunkt vor.", correct: false },
    ],
    explanation: "Eine Annahme unter Aenderungen ist nach Par. 150 Abs. 2 BGB Ablehnung plus neuer Antrag.",
  }),

  q({
    id: "hagen-bgb-at1-025",
    topic: "KE 1 - Annahme",
    kind: "single",
    level: 2,
    priority: 2,
    skill: "distinction",
    estimatedSeconds: 50,
    sources: ["hagenKe1", "bgb151"],
    title: "Annahme ohne Zugang",
    prompt: "Welche Funktion hat Par. 151 BGB beim Vertragsschluss?",
    options: [
      { text: "Er erlaubt in bestimmten Faellen Vertragsschluss ohne Zugang der Annahmeerklaerung.", correct: true },
      { text: "Er ersetzt immer das Angebot.", correct: false },
      { text: "Er macht Schweigen generell zur Annahme.", correct: false },
      { text: "Er gilt nur fuer notariell beurkundete Vertraege.", correct: false },
    ],
    explanation: "Par. 151 BGB verzichtet nur auf den Zugang der Annahmeerklaerung, nicht auf die Annahme als solche.",
  }),

  q({
    id: "hagen-bgb-at1-026",
    topic: "KE 1 - Vertragsschluss",
    kind: "single",
    level: 2,
    priority: 2,
    skill: "mini_case",
    estimatedSeconds: 60,
    sources: ["hagenKe1"],
    title: "Rechtsbindungswille",
    prompt: "A sagt beim Abendessen zu B: 'Ich bringe dich morgen zum Bahnhof.' A erscheint nicht. Wann liegt eher kein Vertrag vor?",
    options: [
      { text: "Wenn nach Anlass, Beziehung und Interessenlage nur eine soziale Gefaelligkeit ohne Rechtsbindungswillen gemeint war.", correct: true },
      { text: "Immer, weil unentgeltliche Zusagen nie rechtlich relevant sind.", correct: false },
      { text: "Nie, weil jede Zusage automatisch ein Vertrag ist.", correct: false },
      { text: "Nur wenn A die Zusage schriftlich widerrufen hat.", correct: false },
    ],
    explanation: "Nicht jede Absprache im Alltag ist rechtsgeschaeftlich. Entscheidend ist der objektiv erkennbare Rechtsbindungswille.",
  }),

  q({
    id: "hagen-bgb-at1-027",
    topic: "KE 1 - Vertragsschluss",
    kind: "multi",
    level: 3,
    priority: 1,
    skill: "schema",
    estimatedSeconds: 75,
    sources: ["hagenKe1", "bgb130", "bgb145", "bgb150", "bgb154"],
    title: "Vertragsschluss-Check",
    prompt: "Welche Pruefungspunkte gehoeren in einen sauberen Vertragsschluss-Check? (Mehrere Antworten moeglich)",
    options: [
      { text: "Liegt ein hinreichend bestimmtes Angebot vor?", correct: true },
      { text: "Ist eine Annahme rechtzeitig und inhaltsgleich erfolgt?", correct: true },
      { text: "Besteht ein offener oder versteckter Einigungsmangel?", correct: true },
      { text: "Ist bereits ein deliktischer Schaden eingetreten?", correct: false },
    ],
    explanation: "Fuer Vertragsschluss sind Angebot, Annahme und Konsens zentral. Deliktischer Schaden gehoert in eine andere Pruefung.",
  }),

  q({
    id: "hagen-bgb-at1-028",
    topic: "KE 1 - Schweigen",
    kind: "single",
    level: 1,
    priority: 1,
    skill: "definition",
    estimatedSeconds: 35,
    sources: ["hagenKe1"],
    title: "Schweigen im Rechtsverkehr",
    prompt: "Welche Grundregel gilt fuer Schweigen im BGB-Vertragsrecht?",
    options: [
      { text: "Schweigen ist grundsaetzlich keine Willenserklaerung.", correct: true },
      { text: "Schweigen bedeutet grundsaetzlich Annahme.", correct: false },
      { text: "Schweigen bedeutet grundsaetzlich Ablehnung mit Schadensersatzpflicht.", correct: false },
      { text: "Schweigen ist nur unter Kaufleuten unbeachtlich.", correct: false },
    ],
    explanation: "Die Grundregel lautet: Wer schweigt, erklaert grundsaetzlich nichts. Ausnahmen muessen besonders begruendet werden.",
  }),

  q({
    id: "hagen-bgb-at1-029",
    topic: "KE 1 - Schweigen",
    kind: "multi",
    level: 2,
    priority: 1,
    skill: "distinction",
    estimatedSeconds: 65,
    sources: ["hagenKe1", "hgb346"],
    title: "Kaufmaennisches Bestaetigungsschreiben",
    prompt: "Welche Voraussetzungen sind fuer die Wirkung eines kaufmaennischen Bestaetigungsschreibens typisch? (Mehrere Antworten moeglich)",
    options: [
      { text: "Vorangegangene Vertragsverhandlungen oder ein vermeintlicher Vertragsschluss.", correct: true },
      { text: "Ein zeitnahes Bestaetigungsschreiben.", correct: true },
      { text: "Kein unverzueglicher Widerspruch des Empfaengers.", correct: true },
      { text: "Immer notarielle Beurkundung des Schreibens.", correct: false },
    ],
    explanation: "Das kaufmaennische Bestaetigungsschreiben ist eine eng begrenzte Ausnahme vom Grundsatz, dass Schweigen nicht erklaert.",
  }),

  q({
    id: "hagen-bgb-at1-030",
    topic: "KE 1 - Schweigen",
    kind: "single",
    level: 2,
    priority: 2,
    skill: "mini_case",
    estimatedSeconds: 60,
    sources: ["hagenKe1", "hgb346"],
    title: "Abweichendes Bestaetigungsschreiben",
    prompt: "Nach Vertragsverhandlungen bestaetigt K den Vertrag, fuegt aber eine erheblich niedrigere Preisabrede ein. V schweigt. Welche Wertung ist naheliegend?",
    options: [
      { text: "Bei erheblichen Abweichungen kann das Schweigen nicht ohne Weiteres als Zustimmung gelten.", correct: true },
      { text: "Jede Abweichung wird automatisch Vertragsinhalt.", correct: false },
      { text: "Schweigen ist nie relevant, auch nicht im kaufmaennischen Verkehr.", correct: false },
      { text: "Der Vertrag ist zwingend nichtig.", correct: false },
    ],
    explanation: "Die Wirkung des kaufmaennischen Bestaetigungsschreibens ist begrenzt. Wesentliche oder redliche Erwartungen sprengende Abweichungen werden nicht einfach durch Schweigen Vertragsinhalt.",
  }),

  q({
    id: "hagen-bgb-at1-031",
    topic: "KE 1 - Schweigen",
    kind: "single",
    level: 2,
    priority: 1,
    skill: "mini_case",
    estimatedSeconds: 55,
    sources: ["hagenKe1", "bgb241a"],
    title: "Unverlangt zugesandte Ware",
    prompt: "Unternehmer U sendet Verbraucher V ungefragt ein Buch und verlangt Zahlung, wenn V es nicht binnen 14 Tagen zurueckschickt. Was ist der Grundgedanke des Par. 241a BGB?",
    options: [
      { text: "Durch unverlangte Zusendung entstehen grundsaetzlich keine Ansprueche gegen den Verbraucher.", correct: true },
      { text: "V muss zahlen, wenn er nicht sofort widerspricht.", correct: false },
      { text: "V muss das Buch immer auf eigene Kosten zuruecksenden.", correct: false },
      { text: "U kann Zahlung verlangen, sobald V das Paket oeffnet.", correct: false },
    ],
    explanation: "Par. 241a BGB schuetzt Verbraucher vor aufgedraengten Leistungen. Schweigen oder Nichtzuruecksenden wird nicht zur Annahme.",
  }),

  q({
    id: "hagen-bgb-at1-032",
    topic: "KE 1 - Dissens",
    kind: "single",
    level: 1,
    priority: 1,
    skill: "definition",
    estimatedSeconds: 35,
    sources: ["hagenKe1", "bgb154"],
    title: "Offener Dissens",
    prompt: "Was kennzeichnet den offenen Dissens nach Par. 154 BGB?",
    options: [
      { text: "Die Parteien wissen, dass ein regelungsbeduerftiger Punkt noch offen ist.", correct: true },
      { text: "Die Parteien glauben irrig, vollstaendig einig zu sein.", correct: false },
      { text: "Eine Partei schweigt auf ein Angebot.", correct: false },
      { text: "Eine Partei widerruft eine Erklaerung nach Zugang.", correct: false },
    ],
    explanation: "Par. 154 BGB betrifft den erkannten Einigungsmangel. Im Zweifel ist der Vertrag noch nicht geschlossen.",
  }),

  q({
    id: "hagen-bgb-at1-033",
    topic: "KE 1 - Dissens",
    kind: "single",
    level: 2,
    priority: 1,
    skill: "definition",
    estimatedSeconds: 40,
    sources: ["hagenKe1", "bgb155"],
    title: "Versteckter Dissens",
    prompt: "Was ist der Kernfall des Par. 155 BGB?",
    options: [
      { text: "Die Parteien meinen, sie seien einig, haben aber einen Punkt nicht geregelt.", correct: true },
      { text: "Die Parteien wissen, dass sie sich ueber den Preis nicht einig sind.", correct: false },
      { text: "Eine Annahme geht verspaetet zu.", correct: false },
      { text: "Eine Willenserklaerung wird vor Zugang widerrufen.", correct: false },
    ],
    explanation: "Par. 155 BGB betrifft den versteckten Einigungsmangel. Entscheidend ist, ob der Vertrag auch ohne den Punkt gewollt war.",
  }),

  q({
    id: "hagen-bgb-at1-034",
    topic: "KE 1 - Dissens",
    kind: "single",
    level: 3,
    priority: 1,
    skill: "mini_case",
    estimatedSeconds: 75,
    sources: ["hagenKe1", "bgb154"],
    title: "Kaufpreis offen",
    prompt: "V und K einigen sich ueber Auto und Uebergabetag. Beim Kaufpreis verlangt V 3.600 Euro, K will hoechstens 3.100 Euro zahlen. Beide wollen den Preis noch klaeren. Ist bereits ein Kaufvertrag geschlossen?",
    options: [
      { text: "Nein, im Zweifel nicht, weil ein offener Einigungsmangel ueber einen wesentlichen Punkt besteht.", correct: true },
      { text: "Ja, weil Fahrzeug und Uebergabetag bereits feststehen.", correct: false },
      { text: "Ja, automatisch zum Mittelwert von 3.350 Euro.", correct: false },
      { text: "Nein, weil Kaufvertraege ueber Autos immer notariell beurkundet werden muessen.", correct: false },
    ],
    explanation: "Der Kaufpreis ist beim Kaufvertrag regelmaessig wesentlich. Ist er bewusst offen, spricht Par. 154 BGB gegen Vertragsschluss.",
  }),

  q({
    id: "hagen-bgb-at1-035",
    topic: "KE 1 - Dissens",
    kind: "single",
    level: 3,
    priority: 2,
    skill: "mini_case",
    estimatedSeconds: 75,
    sources: ["hagenKe1", "bgb155"],
    title: "Nebenkosten vergessen",
    prompt: "V und M schliessen einen Mietvertrag. Beide uebersehen, dass die Umlage bestimmter Nebenkosten nicht geregelt ist. Sie haetten den Vertrag auch ohne diese Regelung geschlossen. Welche Norm ist gedanklich einschlaegig?",
    options: [
      { text: "Par. 155 BGB, weil ein versteckter Einigungsmangel vorliegen kann und der Vertrag dennoch gelten kann.", correct: true },
      { text: "Par. 154 BGB, weil beide den offenen Punkt bewusst verhandelt haben.", correct: false },
      { text: "Par. 130 BGB, weil es um Zugang geht.", correct: false },
      { text: "Par. 241a BGB, weil Nebenkosten unverlangte Waren sind.", correct: false },
    ],
    explanation: "Wenn die Parteien den Regelungspunkt uebersehen, geht es um versteckten Dissens. Der Vertrag kann bestehen, wenn er auch ohne den Punkt geschlossen worden waere.",
  }),

  q({
    id: "hagen-bgb-at1-036",
    topic: "KE 1 - AGB",
    kind: "single",
    level: 1,
    priority: 1,
    skill: "definition",
    estimatedSeconds: 35,
    sources: ["hagenKe1", "bgb305"],
    title: "AGB-Begriff",
    prompt: "Welche Aussage trifft den Begriff der Allgemeinen Geschaeftsbedingungen nach Par. 305 Abs. 1 BGB am besten?",
    options: [
      { text: "Vorformulierte Vertragsbedingungen fuer eine Vielzahl von Vertraegen, die eine Partei der anderen stellt.", correct: true },
      { text: "Jede individuell ausgehandelte Vertragsklausel.", correct: false },
      { text: "Nur Vertragsbedingungen von Banken und Versicherungen.", correct: false },
      { text: "Nur unwirksame Vertragsbedingungen.", correct: false },
    ],
    explanation: "AGB setzen Vorformulierung, Mehrfachverwendungsabsicht und Stellen durch eine Vertragspartei voraus.",
  }),

  q({
    id: "hagen-bgb-at1-037",
    topic: "KE 1 - AGB",
    kind: "single",
    level: 1,
    priority: 1,
    skill: "definition",
    estimatedSeconds: 35,
    sources: ["hagenKe1", "bgb305b"],
    title: "Vorrang der Individualabrede",
    prompt: "Welche Wirkung hat Par. 305b BGB?",
    options: [
      { text: "Individuelle Vertragsabreden haben Vorrang vor Allgemeinen Geschaeftsbedingungen.", correct: true },
      { text: "AGB haben stets Vorrang vor muendlichen Individualabreden.", correct: false },
      { text: "Individualabreden sind nur wirksam, wenn sie in AGB wiederholt werden.", correct: false },
      { text: "Par. 305b BGB regelt nur Verbrauchervertraege im Internet.", correct: false },
    ],
    explanation: "Was individuell vereinbart ist, verdraengt entgegenstehende AGB.",
  }),

  q({
    id: "hagen-bgb-at1-038",
    topic: "KE 1 - AGB",
    kind: "single",
    level: 2,
    priority: 1,
    skill: "definition",
    estimatedSeconds: 40,
    sources: ["hagenKe1", "bgb305c"],
    title: "Ueberraschende Klausel",
    prompt: "Was passiert mit einer ueberraschenden AGB-Klausel im Sinne von Par. 305c Abs. 1 BGB?",
    options: [
      { text: "Sie wird nicht Vertragsbestandteil.", correct: true },
      { text: "Sie wird automatisch zur Individualabrede.", correct: false },
      { text: "Sie ist immer wirksam, wenn der Vertrag unterschrieben wurde.", correct: false },
      { text: "Sie fuehrt stets zur Gesamtnichtigkeit des Vertrags.", correct: false },
    ],
    explanation: "Ueberraschende Klauseln werden nicht Vertragsbestandteil. Das ist eine Einbeziehungsfrage, nicht erst Inhaltskontrolle.",
  }),

  q({
    id: "hagen-bgb-at1-039",
    topic: "KE 1 - AGB",
    kind: "single",
    level: 2,
    priority: 2,
    skill: "distinction",
    estimatedSeconds: 55,
    sources: ["hagenKe1", "bgb305"],
    title: "Ausgehandelte Klausel",
    prompt: "Wann spricht eine Klausel eher gegen AGB-Charakter?",
    options: [
      { text: "Wenn ihr Inhalt im konkreten Vertrag ernsthaft zur Disposition gestellt und individuell ausgehandelt wurde.", correct: true },
      { text: "Wenn sie fuer den Verwender wirtschaftlich wichtig ist.", correct: false },
      { text: "Wenn sie in kleiner Schrift gedruckt wurde.", correct: false },
      { text: "Wenn sie in einem Verbrauchervertrag steht.", correct: false },
    ],
    explanation: "AGB sind gestellt und vorformuliert. Ernsthaftes individuelles Aushandeln kann den AGB-Charakter ausschliessen.",
  }),

  q({
    id: "hagen-bgb-at1-040",
    topic: "KE 1 - AGB",
    kind: "single",
    level: 3,
    priority: 2,
    skill: "mini_case",
    estimatedSeconds: 75,
    sources: ["hagenKe1", "bgb305"],
    title: "Battle of Forms",
    prompt: "Unternehmer A und B verweisen jeweils auf eigene AGB, die einander in Haftungsfragen widersprechen. Der Vertrag wird trotzdem durchgefuehrt. Welche Lernregel ist fuer KE 1 am sinnvollsten?",
    options: [
      { text: "Kollidierende Klauseln werden regelmaessig nicht Vertragsbestandteil; an ihre Stelle tritt dispositives Recht.", correct: true },
      { text: "Immer gelten die AGB desjenigen, der zuerst auf sie verwiesen hat.", correct: false },
      { text: "Immer gelten die AGB desjenigen, der zuletzt auf sie verwiesen hat.", correct: false },
      { text: "Der Vertrag ist zwingend insgesamt nichtig.", correct: false },
    ],
    explanation: "Bei kollidierenden AGB ist sauber zu trennen: Vertragsschluss kann ja sein, widersprechende Klauseln fallen aber heraus.",
  }),

  q({
    id: "hagen-bgb-at1-041",
    topic: "KE 1 - E-Commerce",
    kind: "multi",
    level: 2,
    priority: 2,
    skill: "schema",
    estimatedSeconds: 65,
    sources: ["hagenKe1", "bgb312i", "bgb312j"],
    title: "Elektronischer Geschaeftsverkehr",
    prompt: "Welche Themen gehoeren typischerweise zu den Pflichten beim Vertragsschluss im elektronischen Geschaeftsverkehr? (Mehrere Antworten moeglich)",
    options: [
      { text: "Technische Schritte zum Vertragsschluss transparent machen.", correct: true },
      { text: "Moeglichkeit zur Korrektur von Eingabefehlern bereitstellen.", correct: true },
      { text: "Bei Verbraucher-Bestellungen Button-Loesung beachten.", correct: true },
      { text: "Jeden Onlinevertrag notariell beurkunden lassen.", correct: false },
    ],
    explanation: "Par. 312i und Par. 312j BGB ergaenzen die allgemeinen Regeln um besondere Pflichten im elektronischen Geschaeftsverkehr.",
  }),

  q({
    id: "hagen-bgb-at1-042",
    topic: "KE 1 - E-Commerce",
    kind: "single",
    level: 2,
    priority: 2,
    skill: "mini_case",
    estimatedSeconds: 60,
    sources: ["hagenKe1", "bgb312j"],
    title: "Button-Loesung",
    prompt: "Ein Verbraucher bestellt online. Der letzte Button ist nur mit 'Weiter' beschriftet, obwohl dadurch eine Zahlungspflicht entstehen soll. Welches Problem liegt nahe?",
    options: [
      { text: "Die Bestellsituation kann gegen die besondere Button-Anforderung fuer Verbraucherbestellungen verstossen.", correct: true },
      { text: "Onlinevertraege sind generell nichtig.", correct: false },
      { text: "Der Verbraucher muss immer zahlen, sobald er irgendeinen Button klickt.", correct: false },
      { text: "Die Beschriftung ist rechtlich irrelevant.", correct: false },
    ],
    explanation: "Bei Verbraucherbestellungen muss die Zahlungspflicht klar erkennbar sein. Die Button-Loesung soll versteckte Kostenfallen verhindern.",
  }),

  q({
    id: "hagen-bgb-at1-043",
    topic: "KE 1 - Internetauktion",
    kind: "single",
    level: 2,
    priority: 3,
    skill: "mini_case",
    estimatedSeconds: 70,
    sources: ["hagenKe1", "bgb145"],
    title: "Internetauktion",
    prompt: "Bei einer Onlineauktion stellt V einen Artikel ein und bestimmt, dass das hoechste Gebot bei Ablauf gewinnen soll. Warum ist die Schaufensterlogik hier nicht ohne Weiteres uebertragbar?",
    options: [
      { text: "Weil die Plattformregeln und das Einstellen des Artikels einen verbindlichen Erklaerungsgehalt fuer den Vertragsschluss haben koennen.", correct: true },
      { text: "Weil Onlineauktionen nie zu wirksamen Vertraegen fuehren.", correct: false },
      { text: "Weil Gebote im Internet immer unverbindlich sind.", correct: false },
      { text: "Weil nur notariell beurkundete Gebote gelten.", correct: false },
    ],
    explanation: "Internetauktionen muessen nach ihrem konkreten Regelwerk ausgelegt werden. Sie sind nicht automatisch blosse Schaufensterauslagen.",
  }),

  q({
    id: "hagen-bgb-at1-044",
    topic: "KE 1 - Gutachtenstil",
    kind: "single",
    level: 1,
    priority: 1,
    skill: "schema",
    estimatedSeconds: 35,
    sources: ["hagenKe1"],
    title: "Grundbewegung des Gutachtens",
    prompt: "Welche Reihenfolge beschreibt den Gutachtenstil am besten?",
    options: [
      { text: "Obersatz, Definition, Subsumtion, Ergebnis.", correct: true },
      { text: "Ergebnis, persoenliche Meinung, Zitat, Zusammenfassung.", correct: false },
      { text: "Sachverhalt, Urteilstenor, Vollstreckung, Kosten.", correct: false },
      { text: "Definition, Ergebnis, Obersatz, Ausblick.", correct: false },
    ],
    explanation: "Der Gutachtenstil zwingt zur nachvollziehbaren Pruefung: Frage, Massstab, Anwendung, Ergebnis.",
  }),

  q({
    id: "hagen-bgb-at1-045",
    topic: "KE 1 - Anspruchspruefung",
    kind: "single",
    level: 2,
    priority: 1,
    skill: "schema",
    estimatedSeconds: 45,
    sources: ["hagenKe1", "bgb433"],
    title: "Anspruchsgrundlage zuerst",
    prompt: "Warum beginnt eine zivilrechtliche Fallpruefung regelmaessig mit der Suche nach einer Anspruchsgrundlage?",
    options: [
      { text: "Weil nur eine Norm oder ein Rechtsgrund die begehrte Rechtsfolge tragen kann.", correct: true },
      { text: "Weil der Sachverhalt erst nach der Loesung gelesen wird.", correct: false },
      { text: "Weil Anspruchsgrundlagen nur im Strafrecht vorkommen.", correct: false },
      { text: "Weil alle BGB-Ansprueche ohne Tatbestandsmerkmale funktionieren.", correct: false },
    ],
    explanation: "Die Anspruchsgrundlage ist die rechtliche Bruecke vom Begehren zur Rechtsfolge, etwa Par. 433 Abs. 2 BGB fuer den Kaufpreis.",
  }),

  q({
    id: "hagen-bgb-at1-046",
    topic: "KE 1 - Subsumtion",
    kind: "single",
    level: 2,
    priority: 1,
    skill: "definition",
    estimatedSeconds: 40,
    sources: ["hagenKe1"],
    title: "Subsumtion",
    prompt: "Was bedeutet Subsumtion in der juristischen Fallbearbeitung?",
    options: [
      { text: "Der konkrete Sachverhalt wird unter die Tatbestandsmerkmale einer Norm geordnet.", correct: true },
      { text: "Eine Norm wird auswendig wiedergegeben, ohne den Sachverhalt zu pruefen.", correct: false },
      { text: "Ein Ergebnis wird nach Billigkeit gewaehlt.", correct: false },
      { text: "Der Sachverhalt wird moralisch bewertet.", correct: false },
    ],
    explanation: "Subsumtion ist die Anwendung des abstrakten Tatbestands auf die konkreten Tatsachen.",
  }),

  q({
    id: "hagen-bgb-at1-047",
    topic: "KE 1 - Gutachtenstil",
    kind: "single",
    level: 2,
    priority: 1,
    skill: "error_diagnosis",
    estimatedSeconds: 55,
    sources: ["hagenKe1"],
    title: "Fehler: Ergebnis vor Pruefung",
    prompt: "Welche Formulierung ist im Gutachtenstil methodisch am schwachsten?",
    options: [
      { text: "A hat offensichtlich einen Anspruch, weil das Ergebnis gerecht ist.", correct: true },
      { text: "A koennte gegen B einen Anspruch aus Par. 433 Abs. 2 BGB haben.", correct: false },
      { text: "Dazu muesste zwischen A und B ein Kaufvertrag bestehen.", correct: false },
      { text: "Ein Kaufvertrag kommt durch Angebot und Annahme zustande.", correct: false },
    ],
    explanation: "Das Ergebnis darf nicht behauptet werden, bevor Anspruchsgrundlage, Tatbestand und Subsumtion geprueft sind.",
  }),

  q({
    id: "hagen-bgb-at1-048",
    topic: "KE 1 - Gutachtenstil",
    kind: "single",
    level: 2,
    priority: 2,
    skill: "error_diagnosis",
    estimatedSeconds: 55,
    sources: ["hagenKe1"],
    title: "Fehler: Norm ohne Anwendung",
    prompt: "Warum ist die Antwort 'Par. 154 BGB sagt, dass kein Vertrag vorliegt' in einer Fallloesung oft zu kurz?",
    options: [
      { text: "Weil die Tatbestandsvoraussetzungen der Norm am konkreten Sachverhalt subsumiert werden muessen.", correct: true },
      { text: "Weil Normen im Gutachten nie genannt werden duerfen.", correct: false },
      { text: "Weil Par. 154 BGB nur im Strafrecht gilt.", correct: false },
      { text: "Weil Ergebnisse im Zivilrecht verboten sind.", correct: false },
    ],
    explanation: "Eine Normnennung ersetzt keine Subsumtion. Gerade im Studium zaehlt der Weg zum Ergebnis.",
  }),

  q({
    id: "hagen-bgb-at1-049",
    topic: "KE 1 - Anspruchspruefung",
    kind: "multi",
    level: 2,
    priority: 1,
    skill: "schema",
    estimatedSeconds: 60,
    sources: ["hagenKe1"],
    title: "Wer will was von wem woraus?",
    prompt: "Welche Fragen strukturieren den Einstieg in eine zivilrechtliche Anspruchspruefung? (Mehrere Antworten moeglich)",
    options: [
      { text: "Wer verlangt etwas?", correct: true },
      { text: "Von wem wird es verlangt?", correct: true },
      { text: "Aus welcher Anspruchsgrundlage koennte sich das ergeben?", correct: true },
      { text: "Welche Loesung fuehlt sich spontan am sympathischsten an?", correct: false },
    ],
    explanation: "Die klassische Einstiegsfrage verhindert, dass man vorschnell in allgemeine Erwaegungen abgleitet.",
  }),

  q({
    id: "hagen-bgb-at1-050",
    topic: "KE 1 - Anspruchspruefung",
    kind: "single",
    level: 2,
    priority: 2,
    skill: "distinction",
    estimatedSeconds: 55,
    sources: ["hagenKe1"],
    title: "Einwendung oder Einrede",
    prompt: "Welche Aussage trifft die Grundunterscheidung von Einwendung und Einrede am besten?",
    options: [
      { text: "Eine Einwendung hindert oder vernichtet den Anspruch; eine Einrede hemmt regelmaessig nur seine Durchsetzbarkeit.", correct: true },
      { text: "Einwendungen und Einreden sind immer dasselbe.", correct: false },
      { text: "Einreden gibt es nur im Strafrecht.", correct: false },
      { text: "Einwendungen duerfen im Gutachten nie geprueft werden.", correct: false },
    ],
    explanation: "Die Unterscheidung wird spaeter noch wichtiger. Schon KE 1 sollte das Denkgeruest vorbereiten.",
  }),

  q({
    id: "hagen-bgb-at1-051",
    topic: "KE 1 - Fall Vertragsschluss",
    kind: "single",
    level: 3,
    priority: 1,
    skill: "mini_case",
    estimatedSeconds: 90,
    sources: ["hagenKe1", "bgb145", "bgb150"],
    title: "Preis im Online-Shop falsch",
    prompt: "Ein Online-Shop zeigt versehentlich ein Notebook fuer 49 Euro. K klickt 'zahlungspflichtig bestellen'. Der Shop versendet noch keine Annahme, sondern nur eine automatische Eingangsbestätigung. Welche Frage ist zuerst zu klaeren?",
    options: [
      { text: "Ob die Shop-Darstellung bereits Angebot war oder nur invitatio ad offerendum und ob die Eingangsbestätigung Annahme sein soll.", correct: true },
      { text: "Ob K das Notebook moralisch verdient.", correct: false },
      { text: "Ob Eigentum bereits uebergegangen ist.", correct: false },
      { text: "Ob automatisch ein deliktischer Schadensersatzanspruch entsteht.", correct: false },
    ],
    explanation: "Bei Online-Shops ist die erste Weiche der Vertragsschluss: Angebot/Annahme, Bindungswille und Bedeutung automatischer Nachrichten.",
  }),

  q({
    id: "hagen-bgb-at1-052",
    topic: "KE 1 - Fall Zugang",
    kind: "single",
    level: 3,
    priority: 2,
    skill: "mini_case",
    estimatedSeconds: 80,
    sources: ["hagenKe1", "bgb130"],
    title: "Zugang bei Abwesenheit",
    prompt: "B ist zwei Wochen im Urlaub. A wirft B am ersten Urlaubstag ein Angebot in den Briefkasten. B liest es erst nach Rueckkehr. Wann ist es grundsaetzlich zugegangen?",
    options: [
      { text: "Regelmaessig schon, als nach normaler Verkehrsanschauung mit Leerung des Briefkastens zu rechnen war.", correct: true },
      { text: "Erst bei tatsaechlicher Lektuere nach Rueckkehr.", correct: false },
      { text: "Nie, weil B im Urlaub war.", correct: false },
      { text: "Bereits bei Absendung durch A.", correct: false },
    ],
    explanation: "Individuelle Abwesenheit verhindert Zugang nicht automatisch. Entscheidend ist die objektive normale Kenntnisnahmemoeglichkeit im Machtbereich.",
  }),

  q({
    id: "hagen-bgb-at1-053",
    topic: "KE 1 - Fall Schweigen",
    kind: "single",
    level: 3,
    priority: 2,
    skill: "mini_case",
    estimatedSeconds: 75,
    sources: ["hagenKe1"],
    title: "Privates Schweigen",
    prompt: "A schreibt an B: 'Wenn ich bis Freitag nichts von dir hoere, kaufe ich dein Fahrrad fuer 300 Euro.' B schweigt. Was gilt grundsaetzlich?",
    options: [
      { text: "B ist grundsaetzlich nicht gebunden, weil A Schweigen nicht einseitig zur Annahme erklaeren kann.", correct: true },
      { text: "Der Vertrag kommt immer zustande, weil B nicht widersprochen hat.", correct: false },
      { text: "B muss Schadensersatz leisten, weil Schweigen unhoeflich ist.", correct: false },
      { text: "Das Fahrrad geht automatisch in As Eigentum ueber.", correct: false },
    ],
    explanation: "Der Grundsatz 'Schweigen ist keine Erklaerung' kann nicht einseitig vom Antragenden aufgehoben werden.",
  }),

  q({
    id: "hagen-bgb-at1-054",
    topic: "KE 1 - Fall AGB",
    kind: "single",
    level: 3,
    priority: 2,
    skill: "mini_case",
    estimatedSeconds: 80,
    sources: ["hagenKe1", "bgb305b", "bgb305c"],
    title: "Individualabrede gegen AGB",
    prompt: "V und K vereinbaren muendlich kostenlose Lieferung. In Vs AGB steht 'Lieferung kostet 80 Euro'. Welche Pruefung ist naheliegend?",
    options: [
      { text: "Die muendliche Individualabrede kann nach Par. 305b BGB Vorrang vor der AGB-Klausel haben.", correct: true },
      { text: "AGB gewinnen immer gegen muendliche Abreden.", correct: false },
      { text: "Die Lieferung ist automatisch unmoeglich.", correct: false },
      { text: "Der Vertrag ist zwingend insgesamt nichtig.", correct: false },
    ],
    explanation: "Individualabreden haben Vorrang. Das ist fuer Klausuren eine wichtige erste AGB-Weiche.",
  }),

  q({
    id: "hagen-bgb-at1-055",
    topic: "KE 1 - Fall AGB",
    kind: "single",
    level: 3,
    priority: 3,
    skill: "mini_case",
    estimatedSeconds: 80,
    sources: ["hagenKe1", "bgb305c"],
    title: "Ueberraschende Klausel im Fitnessvertrag",
    prompt: "In einem Fitnessvertrag steht versteckt zwischen Datenschutzklauseln, dass der Kunde zusaetzlich einen teuren Beratungsvertrag abschliesst. Was ist der erste AGB-rechtliche Gedanke?",
    options: [
      { text: "Die Klausel koennte als ueberraschend nicht Vertragsbestandteil werden.", correct: true },
      { text: "Versteckte Klauseln sind immer wirksam, wenn unterschrieben wurde.", correct: false },
      { text: "Datenschutzklauseln machen jede andere Klausel wirksam.", correct: false },
      { text: "Der Kunde ist schon deshalb Eigentuemer des Studios.", correct: false },
    ],
    explanation: "Par. 305c Abs. 1 BGB schuetzt vor ungewoehnlichen Klauseln, mit denen der Vertragspartner nicht zu rechnen braucht.",
  }),

  q({
    id: "hagen-bgb-at1-056",
    topic: "KE 1 - Fall Gutachten",
    kind: "single",
    level: 3,
    priority: 1,
    skill: "error_diagnosis",
    estimatedSeconds: 75,
    sources: ["hagenKe1", "bgb433"],
    title: "Falsche Anspruchsrichtung",
    prompt: "K fragt, ob er von V Uebergabe des gekauften Fahrrads verlangen kann. Welche Anspruchsgrundlage liegt naeher als Par. 433 Abs. 2 BGB?",
    options: [
      { text: "Par. 433 Abs. 1 S. 1 BGB, weil es um den Anspruch des Kaeufers auf Uebergabe und Eigentumsverschaffung geht.", correct: true },
      { text: "Par. 433 Abs. 2 BGB, weil dort immer alle Kaufvertragsansprueche stehen.", correct: false },
      { text: "Par. 241a BGB, weil jedes Fahrrad unverlangte Ware ist.", correct: false },
      { text: "Par. 154 BGB, weil Uebergabe immer Dissens bedeutet.", correct: false },
    ],
    explanation: "Anspruchsrichtung ist zentral: Verkaeufer verlangt Kaufpreis aus Par. 433 Abs. 2, Kaeufer verlangt Uebergabe/Eigentum aus Par. 433 Abs. 1.",
  }),

  q({
    id: "hagen-bgb-at1-057",
    topic: "KE 1 - Fehlerdiagnose",
    kind: "single",
    level: 2,
    priority: 2,
    skill: "error_diagnosis",
    estimatedSeconds: 60,
    sources: ["hagenKe1"],
    title: "Sachverhalt ueberlesen",
    prompt: "Welche Arbeitsweise verhindert am besten, dass man rechtlich wichtige Sachverhaltsdetails uebersieht?",
    options: [
      { text: "Fallfrage und moegliche Anspruchsgrundlage notieren, dann die Tatbestandsmerkmale gezielt mit Sachverhaltsangaben abgleichen.", correct: true },
      { text: "Nur nach bekannten Schlagworten suchen und den Rest ignorieren.", correct: false },
      { text: "Zuerst die Loesung schreiben und danach den Sachverhalt anpassen.", correct: false },
      { text: "Jede Zahl im Sachverhalt als Kaufpreis behandeln.", correct: false },
    ],
    explanation: "Gute Fallbearbeitung ist kontrolliertes Zuordnen: Merkmal fuer Merkmal gegen den Sachverhalt.",
  }),

  q({
    id: "hagen-bgb-at1-058",
    topic: "KE 1 - Transfer",
    kind: "single",
    level: 3,
    priority: 3,
    skill: "transfer",
    estimatedSeconds: 75,
    sources: ["hagenKe1"],
    title: "IP-Bezug: NDA-Verhandlung",
    prompt: "Ein Unternehmen sendet einen NDA-Entwurf mit AGB-aehnlichen Standardklauseln. Die Gegenseite antwortet mit eigenen Standardbedingungen. Welche KE-1-Kompetenz wird hier besonders relevant?",
    options: [
      { text: "Vertragsschluss und kollidierende AGB sauber trennen: Konsens ueber Vertrag ja, einzelne Klauseln gesondert pruefen.", correct: true },
      { text: "Immer annehmen, dass keine Rechtsbindung entsteht.", correct: false },
      { text: "AGB-Fragen sind fuer technische Vertragsarbeit irrelevant.", correct: false },
      { text: "Schweigen ersetzt immer die Unterschrift.", correct: false },
    ],
    explanation: "Gerade in techniknaher Vertragsarbeit hilft KE 1: Vertragsschluss, Bindungswille, Schweigen und AGB-Kollision auseinanderhalten.",
  }),

  q({
    id: "hagen-bgb-at1-059",
    topic: "KE 1 - Wiederholungsanker",
    kind: "multi",
    level: 3,
    priority: 1,
    skill: "schema",
    estimatedSeconds: 75,
    sources: ["hagenKe1", "bgb130", "bgb145", "bgb150", "bgb154", "bgb305"],
    title: "KE-1-Kernlandkarte",
    prompt: "Welche Themen bilden die tragenden Wiederholungsanker von KE 1? (Mehrere Antworten moeglich)",
    options: [
      { text: "Willenserklaerung und Zugang", correct: true },
      { text: "Angebot, Annahme und Dissens", correct: true },
      { text: "AGB-Einbeziehung und Gutachtenstil", correct: true },
      { text: "Deliktische Produzentenhaftung im Detail", correct: false },
    ],
    explanation: "Deliktische Haftung kommt spaeter. KE 1 baut vor allem die Sprache und Technik fuer Rechtsgeschaefte und Vertragsschluss.",
  }),

  q({
    id: "hagen-bgb-at1-060",
    topic: "KE 1 - Exam Warm-up",
    kind: "single",
    level: 3,
    priority: 1,
    skill: "schema",
    estimatedSeconds: 90,
    sources: ["hagenKe1"],
    title: "Mini-Gutachten in einem Satz",
    prompt: "Welche Antwort hat die beste Gutachtenstruktur fuer die Frage, ob ein Vertrag geschlossen wurde?",
    options: [
      { text: "Ein Vertrag koennte durch Angebot und Annahme zustande gekommen sein; das Verhalten des A muesste als Angebot und Bs Reaktion als rechtzeitige, inhaltsgleiche Annahme auszulegen sein.", correct: true },
      { text: "Ein Vertrag liegt vor, weil beide irgendwie miteinander gesprochen haben.", correct: false },
      { text: "Kein Vertrag, weil A spaeter unzufrieden war.", correct: false },
      { text: "Vertragsschluss ist egal, weil das Ergebnis wirtschaftlich sinnvoll ist.", correct: false },
    ],
    explanation: "Die gute Antwort benennt Obersatz und Pruefungsmerkmale. Sie springt nicht direkt ins Ergebnis.",
  }),
];

